type EmailFactory = (props: { email: string; subject?: string; body?: string }) => string;

export const emailLinkFactory: EmailFactory = ({ email, subject = '', body = '' }) =>
  `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

export const isEmailValid = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return !!email.match(emailRegex);
};
